import { createContext, useContext } from 'react';

export const UIContext = createContext({
  device: 'desktop',
  mobileSidebarOpen: false,
  setMobileSidebarOpen: () => {}
});

export const useUIContext = () => useContext(UIContext);
